module.exports = __webpack_public_path__ + "static/media/info.fe1cae42.svg";